import styles from "./periodEventsList.module.less";
import {Stack} from "@src/CommonComponents/Stack/Stack.tsx";
import cn from "classnames";
import {useState} from "react";
import {Title_20_Coral_Strong_emphasis_20} from "@UI/typography/generated/typography.tsx";
import {Button, ButtonType} from "@UI/components/controls/Button/Button.tsx";
import {ArrowChevronDown} from "@UI/components/icons/ArrowChevronDown.tsx";
import {ColorNames} from "@UI/theme/generated/ColorNames.ts";
import {
    HistoryDaysGroupedEventsElement
} from "@src/CommonComponents/EventsHistoryElement/HistoryDaysGroupedEventsElement/HistoryDaysGroupedEventsElement.tsx";
import {EmployeeWithWorkdays} from "@src/Store/employeesStore.ts";

export const PeriodEventsList = ({employee}: {employee: EmployeeWithWorkdays}) => {
    const [hidden, setHidden] = useState<boolean>(true);
    return(
        <Stack direction={"column"} gap={24} className={styles.root} >
            <Stack className={styles.employeeInfo} direction={"column"}>
                <Stack justifyContent={"space-between"} style={{width: "100%"}}  alignItems={"center"}>
                    <Stack direction={"column"}>
                        <Stack className={styles.employeeName}>
                            <Title_20_Coral_Strong_emphasis_20>
                                {employee?.last_name} {employee?.first_name}
                            </Title_20_Coral_Strong_emphasis_20>
                        </Stack>
                    </Stack>
                    <Button
                        type={ButtonType.clickableIcon}
                        icon={<ArrowChevronDown/>}
                        className={styles.expandButton}
                        color={ColorNames.OBSIDIAN}
                        onClick={() => setHidden(!hidden)}
                    />
                </Stack>
            </Stack>
            <Stack direction={"column"} gap={8} className={cn(styles.expandableGroup, {[styles.hidden]: hidden})}>
                {employee?.workdays?.length === 0
                    ?
                    <div className={styles.eventElement}>
                        <HistoryDaysGroupedEventsElement/>
                    </div>
                    :
                    employee?.workdays.map(e =>
                        <HistoryDaysGroupedEventsElement workday={e} key={e.id} withBorder={true}/>
                    )
                }
            </Stack>
        </Stack>
    )
}